import React from 'react';
import { Route } from 'react-router-dom';
import AllUsers from '@/pages/user-management/AllUsers';
import ResetPassword from '@/pages/user-management/ResetPassword';
import BlockUsers from '@/pages/user-management/BlockUsers';
import LoginHistory from '@/pages/user-management/LoginHistory';

export const userManagementRoutes = (
  <React.Fragment>
    <Route path="user-management/all-users" element={<AllUsers />} />
    <Route path="user-management/reset-password" element={<ResetPassword />} />
    <Route path="user-management/block-users" element={<BlockUsers />} />
    <Route path="user-management/login-history" element={<LoginHistory />} />
  </React.Fragment>
);
